// Create Post Page
// Page wrapper for creating posts

import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { CreatePost } from '../../components/CommunityChatRooms/CreatePost';
import { CommunityService } from '../../services/Community/communityService';

export const CreatePostPage: React.FC = () => {
  const { personaId, roomId } = useParams<{ personaId?: string; roomId?: string }>();
  const navigate = useNavigate();
  const communityId = personaId || roomId || '';

  const handleSubmit = async (title: string, body: string) => {
    try {
      const newPost = await CommunityService.createPost(communityId, title, body);
      // Navigate to post detail
      if (personaId) {
        navigate(`/community-chat-rooms/${personaId}/post/${newPost.id}`);
      } else if (roomId) {
        navigate(`/community-chat-rooms/room/${roomId}/post/${newPost.id}`);
      }
    } catch (error) {
      console.error('Error creating post:', error);
      throw error;
    }
  };

  const handleCancel = () => {
    if (personaId) {
      navigate(`/community-chat-rooms/${personaId}`);
    } else if (roomId) {
      navigate(`/community-chat-rooms/room/${roomId}`);
    } else {
      navigate('/community-chat-rooms');
    }
  };

  return (
    <CreatePost
      communityId={communityId}
      onSubmit={handleSubmit}
      onCancel={handleCancel}
    />
  );
};

